import { FluentProvider, Spinner } from '@fluentui/react-components'

import { theme } from '../styles/theme'

export default function PageLoading() {
  return (
    <FluentProvider
      theme={theme}
      className="theme-v2"
      style={{ height: 'stretch', backgroundColor: 'inherit' }}
    >
      <Spinner size="huge" style={{ height: '100%' }} />
    </FluentProvider>
  )
}
